import { ITaiKhoanResponseBase } from "@/core/interfaces/ApiResponses";
import AccountantService from "@/core/services/Accountant.service";
import { computed, ref, watch } from "vue";

const useTaiKhoan = () => {
  const taiKhoanData = ref<{
    id: number;
    maTaiKhoan: string;
    maChiTiet?: string;
    tenTaiKhoan: string;
  }>({
    id: 0,
    maChiTiet: "",
    maTaiKhoan: "",
    tenTaiKhoan: "",
  });

  const onSelectTaiKhoan = ({
    taiKhoanItem: {
      id: id_tai_khoan,
      ma_tai_khoan,
      ma_chi_tiet,
      ten_tai_khoan,
    },
  }: {
    taiKhoanItem: ITaiKhoanResponseBase;
  }) => {
    taiKhoanData.value = {
      tenTaiKhoan: ten_tai_khoan,
      id: id_tai_khoan,
      maTaiKhoan: ma_tai_khoan,
      maChiTiet: (ma_chi_tiet as unknown as string) ?? "",
    };
  };

  const clearTaiKhoanData = async (type: "tai_khoan" | "chi_tiet") => {
    if (type === "tai_khoan") {
      // Assign atomically so child watchers see a fully cleared state
      taiKhoanData.value = {
        id: 0,
        maTaiKhoan: "",
        maChiTiet: "",
        tenTaiKhoan: "",
      };

      return;
    }

    taiKhoanData.value = {
      ...taiKhoanData.value,
      maChiTiet: "",
    };

    if (!taiKhoanData.value.maTaiKhoan) {
      return;
    }

    try {
      const {
        data: {
          data: { data },
        },
      } = await AccountantService.fetch(taiKhoanData.value.maTaiKhoan, "");

      const taiKhoan = data.find(
        ({ ma_tai_khoan }) => ma_tai_khoan === taiKhoanData.value.maTaiKhoan
      );

      if (taiKhoan) {
        taiKhoanData.value = {
          ...taiKhoanData.value,
          id: taiKhoan.id,
          tenTaiKhoan: taiKhoan.ten_tai_khoan,
        };
      }
    } catch (error) {
      console.log(error);
    }
  };

  const tkData = computed(() => taiKhoanData.value);

  const setTkData = (value, type: "ma_tk" | "ma_ct" | "ten_tk") => {
    switch (type) {
      case "ten_tk":
        taiKhoanData.value = {
          ...taiKhoanData.value,
          tenTaiKhoan: value,
        };

        break;
      case "ma_ct":
        taiKhoanData.value = {
          ...taiKhoanData.value,
          maChiTiet: value,
        };

        break;
      case "ma_tk":
      default:
        taiKhoanData.value = {
          ...taiKhoanData.value,
          maTaiKhoan: value,
        };
    }
  };

  watch(
    tkData,
    (newVal) => {
      console.log("tkData changed", newVal);
    },
    { deep: true }
  );

  return {
    clearTaiKhoanData,
    onSelectTaiKhoan,
    setTkData,
    taiKhoanData: computed(() => taiKhoanData.value),
    tkData,
  };
};

export default useTaiKhoan;
